import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { TagsGateway } from '@domain/gateway/tags-gateway';
import { TagsModel, TagsServerModel } from '@domain/entities/tags.model';

@Injectable({
    providedIn: 'root',
})
export class TagService extends TagsGateway {
    private endpoint = 'wp-json/wc/v3/products/tags';

    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Get tags
     * @param params (Optional)
     * @returns Observable of tags entity
     */
    read(params?: HttpParams): Observable<TagsServerModel[]> {
        return this._http.get<TagsServerModel[]>(
            `${environment.host}${this.endpoint}`,
            {
                params,
            }
        );
    }

    /**
     * @description Create tags
     * @returns Observable of tags entity
     */
    create(form: TagsModel): Observable<TagsServerModel> {
        return this._http.post<TagsServerModel>(
            `${environment.host}${this.endpoint}`,
            form
        );
    }

    /**
     * @description Read a tags
     * @returns Observable of tags entity description
     */
    readById(id: number): Observable<TagsServerModel> {
        return this._http.get<TagsServerModel>(
            `${environment.host}${this.endpoint}/${id}`
        );
    }

    /**
     * @description Update tags
     * @returns Observable of tags entity
     */
    update(id: number, form: TagsModel): Observable<TagsServerModel> {
        return this._http.put<TagsServerModel>(
            `${environment.host}${this.endpoint}/${id}`,
            form
        );
    }

    /**
     * @description Delete tags
     * @returns Observable of tags entity
     */
    delete(id: number): Observable<TagsServerModel> {
        return this._http.delete<TagsServerModel>(
            `${environment.host}${this.endpoint}/${id}?force=true`
        );
    }
}
